export enum OrderTypeEnum {
  Single = 'Single',
  Birthday = 'Birthday',
  Group = 'Group',
  Giftcard = 'Giftcard',
  EventSlot = 'EventSlot',
  Refund = 'Refund',
  Product = 'Product',
}
